import React, { useState } from "react";
import { ChevronDownIcon, ChevronUpIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";

function PolicyPopup({ onClose, lang }) {
  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-[70]">
      <div
        className="relative w-[90%] max-w-xl h-[80%] rounded-xl overflow-hidden shadow-xl"
        style={{
          backgroundImage: "url('/bg/policy.webp')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-4 text-red-700 text-2xl drop-shadow-lg"
        >
          <XMarkIcon className="h-8 w-8" />
        </button>

        {/* Scrollable Content */}
        <div className="p-6 h-full overflow-y-auto text-white text-sm leading-relaxed bg-black/30">
          <h2 className={`text-lg font-bold mb-4 ${lang == "TH" ? "font-thai" : "font-eng"}`}>{lang == "TH" ? "ข้อกำหนดการใช้ทรัพยากรโปรเจกต์" : "Project Resource Usage Policy"}</h2>
          <p className={`mb-4 ${lang == "TH" ? "font-thai" : "font-eng"}`}>
            {lang == "TH" ? 
            "ทรัพยากร ห้ามนำ รูปภาพ วิตีโอ โลโก้ เสียง และองค์ประกอบอื่นใดที่เป็นทรัพยากรของทางค่ายไปใช้ในเชิงพาณิชย์ไม่ว่ารูปแบบใด หากไม่ได้รับอนุญาตล่วงหน้า" : 
            "Project resources, including images, videos, logos, audio, and any other materials belonging to the project, must not be used for commercial purposes in any form without prior permission."}
          </p>

          <h3 className={`text-md font-semibold mt-4 mb-2 ${lang == "TH" ? "font-thai" : "font-eng"}`}>{lang == "TH" ? "ข้อกำหนดการจัดทำผลงาน" : "Content Creation Guidelines"}</h3>
          <p className={`mb-4 ${lang == "TH" ? "font-thai" : "font-eng"}`}>
            {lang == "TH" ? 
            "ผลงาน FANMADE , GOODS ผลงานที่อนุญาตให้จัดทำได้ต้องเป็นการทำแจกเป็น Giveaway และต้องเป็นงานสร้างสรรค์ใหม่ทั้งหมดไม่ใช้ทรัพยากรโปรเจกต์โดยตรง หรือเป็นการทำเลียนแบบ ทำซ้ำ และให้ใส่เครดิตถึงโปรเจกต์ทุกครั้ง ทั้งนี้ต้องไม่ก่อให้เกิดความเข้าใจผิดว่าเป็นผลงานของศิลปินหรือโปรเจกต์ ไม่อนุญาตให้จัดทำเพื่อใช้ในเชิงพาณิชย์ไม่ว่ารูปแบบไหน" : 
            "Fan-made works and goods that are permitted must be created solely for giveaway purposes. All works must be entirely original creations and must not directly use project resources, nor imitate or reproduce official materials. Proper credit to the project must be clearly stated at all times, and the work must not create any misunderstanding that it is an official product of the artist or the project. Commercial use of fan-made works and goods of any kind is strictly prohibited."}
          </p>
          <p className={`mb-4 ${lang == "TH" ? "font-thai" : "font-eng"}`}>
            {lang == "TH" ? 
            "ผลงาน FANFICTION , FANART , VIDEO ต้องไม่ก่อให้เกิดความเข้าใจผิดว่าเป็นผลงานของศิลปินหรือโปรเจกต์ และต้องไม่ขัดต่อหลักศีลธรรมอันดี กฎหมาย การแสดงออกทางการเมือง หรือในประเด็นที่เกี่ยวกับ ชาติ ศาสนา พระมหากษัตริย์ และให้ใส่เครดิตถึงโปรเจกต์ทุกครั้ง อนุญาตให้จัดทำขึ้นใช้ในเชิงพาณิชย์ เพื่อการโปรโมทแก่ตัว Vtuber และ/หรือโปรเจกต์ได้เท่านั้น" : 
            "Fanfiction, fanart, and videos must not cause any misunderstanding that they are official works of the artist or the project. The content must not violate public morality, applicable laws, political expression, or issues related to nation, religion, or the monarchy. Proper credit to the project must be included at all times. Commercial use is permitted only when the purpose is to promote the VTuber and/or the project."}
          </p>

          <h3 className={`text-md font-semibold mt-4 mb-2 ${lang == "TH" ? "font-thai" : "font-eng"}`}>{lang == "TH" ? "การ COSPLAY" : "Cosplay Guidelines"}</h3>
          <p className={`mb-4 ${lang == "TH" ? "font-thai" : "font-eng"}`}>
            {lang == "TH" ? 
            "อนุญาตให้แต่งกายเลียนแบบศิลปินในลักษณะการ COSPLAY เพื่อหารายได้แต่ต้องไม่ขัดหลักศีลธรรมอันดี กฎหมายการแสดงออกทางการเมือง หรือในประเด็นที่เกี่ยวกับ ชาติ ศาสนา พระมหากษัตริย์ อนุญาตให้จัดทำชุดคอสเพลย์ตัวละคร Vtuber ตาม Official เพื่อจำหน่าย และ/หรือการปล่อยเช่าได้ สินค้าจากการคอสเพลย์อนุญาติให้จำหน่าย และ/หรือแจกจ่ายได้โดยต้องใส่เครดิตถึงโปรเจกต์ทุกครั้ง" : 
            "Cosplaying as the artist is permitted for income-generating purposes, provided that it does not violate public morality, laws, political expression, or issues related to nation, religion, or the monarchy. Official VTuber character cosplay costumes may be produced for sale and/or rental. Goods related to cosplay may be sold and/or distributed, provided that proper credit to the project is clearly stated."}
          </p>

          <h3 className={`text-md font-semibold mt-4 mb-2 ${lang == "TH" ? "font-thai" : "font-eng"}`}>{lang == "TH" ? "การจัดกิจกรรมของแฟนคลับ" : "Fan Activities Guidelines"}</h3>
          <p className={`mb-4 ${lang == "TH" ? "font-thai" : "font-eng"}`}>
            {lang == "TH" ? 
            "อนุญาตให้ทำกิจกรรมแฟนคาเฟ่หรือโปรเจกต์ของแฟนคลับได้ โดยต้องไม่ใช้ทรัพยากรทางโปรเจกต์โดยตรง และต้องอยู่ในความเหมาะสมโดยไม่ก่อให้เกิดความเสียหายต่อชื่อเสียงศิลปินหรือโปรเจกต์ รวมถึงต้องไม่ขัดต่อกฎหมายหรือระเบียบสาธารณะ" : 
            "Fan cafés and fan-organized projects are permitted, provided that official project resources are not used directly. All activities must be conducted appropriately and must not cause harm to the reputation of the artist or the project, and must comply with applicable laws and public regulations."}
          </p>

          <h3 className={`text-md font-semibold mt-4 mb-2 ${lang == "TH" ? "font-thai" : "font-eng"}`}>{lang == "TH" ? "ข้อห้ามอื่น ๆ" : "Additional Restrictions"}</h3>
          <p className={`mb-4 ${lang == "TH" ? "font-thai" : "font-eng"}`}>
            {lang == "TH" ? 
            "ห้ามรับบทแสดงแทนศิลปิน (ROLEPLAY) หรือแอบอ้างตัวตนศิลปิน ไม่ว่าจะในกิจกรรมใดก็ตาม เว้นแต่เป็นการกระทำที่อยู่ภายใต้การกำกับหรือได้รับอนุญาตจากโปรเจกต์โดยชัดแจ้ง ไม่อนุญาตให้ทำผลงานใดที่มีลักษณะ 18+ ทั้งสิ้น ทางโปรเจกต์จะไม่รับผิดชอบต่อความเสียหายใด ๆ ที่เกิดขึ้นตามข้อกำหนดนี้" : 
            "Impersonating the artists or role-playing as the artists in any activity is strictly prohibited, unless the action is under direct supervision or has received explicit authorization from the project. All content of an 18+ nature is strictly prohibited. The project shall not be responsible for any damages arising from violations of these policies."}
          </p>
        </div>
      </div>
    </div>
  );
}

export default function Navbar() {
  const [showContactDropdown, setShowContactDropdown] = useState(false);
  const [policyOpen, setPolicyOpen] = useState(false);
  const { lang, toggleLang } = useLanguage();

  return (
    <nav className="w-full bg-black shadow-md py-4 px-8 flex justify-between items-center h-16">
      <Link to="/" className="font-bold text-white text-xl font-eng">Home</Link>

      <ul className="flex gap-6 text-white font-medium relative">
        <li
          className="cursor-pointer transition hover:text-red-400 font-eng"
          onClick={toggleLang}
        >
          {lang}
        </li>
        <li
          className="cursor-pointer transition hover:text-red-400 font-eng"
          onClick={() => setPolicyOpen(true)}
        >
          Policies</li>
        <li
          className="cursor-pointer transition hover:text-red-400 relative"
          onClick={() => setShowContactDropdown((prev) => !prev)}
        >
          <span className="flex items-center gap-1 font-eng">
            Contact Us
            {showContactDropdown ? (
              <ChevronUpIcon className="w-4 h-4" />
            ) : (
              <ChevronDownIcon className="w-4 h-4" />
            )}
          </span>

          {showContactDropdown && (
            <div className="absolute top-full right-0 mt-2 bg-white rounded-lg shadow-xl py-2 w-48 z-50">
              <a
                href="https://www.facebook.com/people/Once-A-Live-Project/61556824655205/"
                className="block px-4 py-2 text-gray-700 hover:bg-gray-100 transition font-eng"
                target="_blank"
              >
                Facebook
              </a>
              <a
                href="https://x.com/OAL_PROJECT"
                className="block px-4 py-2 text-gray-700 hover:bg-gray-100 transition font-eng"
                target="_blank"
              >Twitter</a>
              <a
                href="https://discord.com/invite/nYG2yp22bm"
                className="block px-4 py-2 text-gray-700 hover:bg-gray-100 transition font-eng"
                target="_blank"
              >Discord</a>
              <a
                href="#"
                className="block px-4 py-2 text-gray-700 hover:bg-gray-100 transition font-eng"
                target="_blank"
              >Email</a>
            </div>
          )}
        </li>
        {policyOpen && <PolicyPopup onClose={() => setPolicyOpen(false)} lang = {lang} />}
      </ul>
    </nav>
  );
}
